import React from 'react';

import classNames from 'classnames';

import XMarkIcon from 'Assets/icons/xmark.svg';

/**
 * One chosen item of a multi-select, removable unless the control is disabled.
 */
export default function SelectionChip({ label, onRemove, disabled, className }) {
    return (
        <span
            className={classNames(
                'tw-inline-flex tw-items-center tw-gap-x-1.5 tw-rounded-[14px] tw-bg-blue-25 tw-text-charcoal tw-text-[11.5px] tw-font-medium tw-px-2.5 tw-py-1',
                className,
            )}
        >
            <span className="tw-truncate tw-max-w-[180px]">{label}</span>
            {!disabled && (
                <button
                    type="button"
                    className="tw-flex tw-items-center tw-text-blue hover:tw-text-dark-blue"
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    aria-label={$t('Remove')}
                >
                    <XMarkIcon className="tw-w-2 tw-h-2" />
                </button>
            )}
        </span>
    );
}
